import React from "react"
import _ from "lodash"

import "./Paginator.scss"
import windowAroundValue from "@helper/windowAroundValue"
import I18n from "@helper/i18nInstance"

export interface PaginatorInfo {
  current: number,
  total: number
}

const Paginator: React.FC<{info: PaginatorInfo, toPage: (page: number) => void}> = ({info, toPage}) => {
  const pages = windowAroundValue(info.current, 5, 1, info.total)
  const hasPrev = info.current > 1
  const hasNext = info.current < info.total

  return <div className="neo__paginator">
    {hasPrev
      ? <a className="neo__paginator__prev" onClick={() => toPage(info.current - 1)}>{I18n.t("paginate.prev")}</a>
      : <span className="neo__paginator__prev">{I18n.t("paginate.prev")}</span>}
    {_.map(pages, (p) => {
      const isCurrent = p === info.current
      const className = [
        "neo__paginator__page",
        isCurrent ? "neo__paginator__page--current" : "",
      ].join(" ")
      return <a key={p} className={className} onClick={isCurrent ? undefined : () => toPage(p)}>{p}</a>
    })}
    {hasNext
      ? <a className="neo__paginator__next" onClick={() => toPage(info.current + 1)}>{I18n.t("paginate.next")}</a>
      : <span className="neo__paginator__next">{I18n.t("paginate.next")}</span>}
  </div>
}

export default Paginator
